export default __webpack_public_path__ + "static/media/instagram.979cbc93.svg";